<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
      v-show="!hideTitle"
      :title="page"
      icon="timer"
    ></vuse-section-definition>

    <v-container fluid class="">
      <template>
        <v-row>
          <v-col>
            <v-card>
              <v-card-text>
                <DateRangePicker solo v-model="dateRange" />
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn color="info" @click="applySearch()" :loading="loading"
                  >Apply</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-card>
              <v-card-title>
                <v-spacer />

                <v-btn
                  color="info"
                  @click="generateReport()"
                  v-show="dataItems.length > 0"
                  :disabled="loading"
                  >Generate PDF</v-btn
                >
                <v-menu offset-y :close-on-content-click="false">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      icon
                      small
                      class="content-ma-0"
                      v-on="on"
                      v-show="dataItems.length > 0"
                    >
                      <v-icon small>settings</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item>
                      <v-list-item-title>
                        <v-text-field
                          label="Total rows per page"
                          v-model="pdfRowPerPage"
                          type="number"
                        />
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-card-title>
              <v-card-text>
                <vue-html2pdf
                  :show-layout="false"
                  :float-layout="false"
                  :enable-download="false"
                  :preview-modal="false"
                  :filename="`statement_${clientId}`"
                  :pdf-quality="2"
                  :manual-pagination="true"
                  pdf-format="a4"
                  ref="html2Pdf"
                  pdf-content-width="100%"
                  @beforeDownload="beforeDownload($event)"
                >
                  <section slot="pdf-content">
                    <v-container class="pdf-item">
                    <v-row>
                      <v-col>
                        <div class="text-center">
                          <h1 style="font-size: 20px">Statement Invoice</h1>
                          <h1 style="font-size: 15px">
                            {{ pdfSubTitle }}
                            
                          </h1>
                        </div>
                        <hr />
                      </v-col>
                    </v-row>
                    
                    <v-row>
                      <v-col cols="6" lg="6" md="6" style="padding:0;">
                        <h5>Balance Summary</h5>
                        <table class="pdf2 no-border">
                          <tbody>
                            <tr>
                              <td width="30%">Balance</td>
                              <td>
                                <v-chip>{{
                                  summary.totalBalance | formatPrice
                                }}</v-chip>
                              </td>
                            </tr>
                            <tr>
                              <td>Total Invoice</td>
                              <td>
                                <v-chip>{{
                                  summary.totalInvoice | formatPrice
                                }}</v-chip>
                              </td>
                            </tr>
                            <tr>
                              <td>Payments</td>
                              <td>
                                <v-chip>{{
                                  summary.totalPaid | formatPrice
                                }}</v-chip>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </v-col>
    
                      <v-col cols="6" lg="6" md="6" style="padding:0;">
                        <h5>Account Summary</h5>
                        <table class="pdf2 no-border">
                          <tbody>
                            <tr>
                              <td width="30%">First Name</td>
                              <td>{{ client.firstName }}</td>
                            </tr>
                            <tr>
                              <td>Last Name</td>
                              <td>{{ client.lastName }}</td>
                            </tr>
                            <tr>
                              <td>Address</td>
                              <td>
                                {{ client.address }} {{ client.city }}
                                <StateView :value="client.state" />,
                                {{ client.zipcode }}
                              </td>
                            </tr>
                            <tr>
                              <td>Email</td>
                              <td>{{ client.email }}</td>
                            </tr>
                            <tr>
                              <td>Phone</td>
                              <td>{{ client.phoneNumber }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </v-col>
                    </v-row>
                    </v-container>
                    <section class="pdf-item">
                      <v-skeleton-loader
                        v-if="loading"
                        class="mx-auto"
                        type="table"
                      ></v-skeleton-loader>
                      <table v-else class="pdf2">
                        <thead>
                          <tr>
                            <th>Date</th>
                            <th>Ref Number</th>
                            <th>Description</th>
                            <th>Notes</th>
                            <th>Invoice Amount</th>
                            <th>Payments</th>
                            <th>Balance</th>
                          </tr>
                        </thead>

                        <tbody>
                          <tr
                            v-for="(item, i) in dataItems"
                            :key="item.id"
                            :class="
                              i !== 0 && i % pdfRowPerPage == 0
                                ? `html2pdf__page-break`
                                : ``
                            "
                          >
                            <td>{{ item.date | formatDate }}</td>
                            <td>{{ item.ref }}</td>
                            <td>
                              {{ item.description }}
                              <invoice-status-chip
                                v-if="item.status"
                                :status="item.status"
                              />
                            </td>
                            <td>{{ item.notes }}</td>
                            <td v-if="item.gr == 'invoice'">
                              {{ item.invoiceTotal | formatPrice }}
                            </td>
                            <td v-else>-</td>

                            <td v-if="item.gr == 'history'">
                              {{ item.paid | formatPrice }}
                            </td>
                            <td v-else>-</td>

                            <td v-if="item.gr == 'history'">
                              {{ item.clientBalance | formatPrice }}
                            </td>
                            <td v-else>-</td>
                          </tr>
                        </tbody>
                      </table>
                    </section>
                  </section>
                </vue-html2pdf>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </template>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import formatterMixin from "@/mixins/formatterMixin";
import StateView from "../../components/StateView.vue";
import InvoiceStatusChip from "../../components/InvoiceStatusChip.vue";
import DateRangePicker from "components/DateRangePicker";
import VueHtml2pdf from "vue-html2pdf";
import moment from "moment";

export default {
  props: {
    clientId: Number,
    hideTitle: Boolean,
  },
  mixins: [formatterMixin],
  components: {
    VueHtml2pdf,
    StateView,
    InvoiceStatusChip,
    DateRangePicker,
  },
  data: () => ({
    loading: false,
    showTimeEntryForm: false,
    showForm: false,
    showDelete: false,
    selectedItem: {},
    pdfRowPerPage: 25,
    page: "Statement Invoice",
    dateRange: {
      start: moment().subtract(1, "month").format("YYYY-MM-DD"),
      end: moment().format("YYYY-MM-DD"),
    },

    filter: {
      keyword: "",
      clientId: "",
      status: "",
    },

    headers: [
      { text: "Action", value: "actions", sortable: false },
      { text: "", value: "timeAction", sortable: false },
      {
        text: "Clients",
        align: "start",
        sortable: false,
        value: "client",
      },
      { text: "Name", value: "name" },
      { text: "Status", value: "completed" },
      { text: "Description", value: "description" },
      { text: "Time", value: "time" },
    ],

    footerProps: {
      // itemsPerPageOptions: [10, 15, 50, 100],
    },
  }),
  computed: {
    ...mapGetters("account", ["hasAccess"]),
    ...mapState({
      account: (state) => state.account,
      client: (state) => state.client.single,
      summary: (state) => state.statement.summary,
    }),

    pdfSubTitle() {
      const {start, end} = this.dateRange;
      if (start && end) {
        if (start === end) {
          return start;
        } else {
          return `${start} - ${end}`;
        }
      } else {
        return `All Time`;
      }
    },

    dataItems() {
      let items = this.$store.getters["statement/getAll"];
      let _items = [];
      items.forEach((item) => {
        let histories = item.transactionHistory || [];
        delete item.transactionHistory;
        _items.push({
          ...item,
          gr: "invoice",
          ref: item.referenceNumber ? `#${item.referenceNumber}` : ``,
          notes: item.description ? item.description : "-",
          description: `Invoice #${item.id}`,
          date: item.dueDate,
        });

        let totalInvoice = item.invoiceTotal + item.invoiceTaxTotal;
        histories.forEach((history) => {
          totalInvoice -= history.amount;
          _items.push({
            ...history,
            gr: "history",
            ref: ``,
            notes: history.notes,
            description: `Payment with ${history.method} for invoice #${item.id}`,
            paid: history.amount,
            invoiceTotal: 0,
            invoiceTaxTotal: 0,
            clientBalance: totalInvoice,
          });
        });
      });

      return _items;
    },

    totalPaid() {
      let total = 0;
      this.dataItems.map((item) => {
        total += item.paid;
      });
      return total;
    },

    totalInvoice() {
      let total = 0;
      this.dataItems.map((item) => {
        total += item.invoiceTotal + item.invoiceTaxTotal;
      });
      return total;
    },

    totalBalance() {
      return this.totalInvoice - this.totalPaid;
    },
  },
  watch: {
  },

  async mounted() {
    await this.refresh();
  },

  beforeDestroy() {},

  methods: {
    ...mapActions({
      invoiceGetStatementAll: "statement/getStatementAll",
      invoiceGetStatementSummary: "statement/getStatementSummary",
    }),

    async beforeDownload({ html2pdf, pdfContent }) {
      await html2pdf()
        .set({
          html2canvas: {
            scrollX: 0,
            scrollY: 10,
          },
        })
        .from(pdfContent)
        .toPdf()
        .get("pdf")
        .save();
    },

    async applySearch() {
      this.loading = true;
      await this.refresh();
      this.loading = false;
    },

    generateReport() {
      this.$refs.html2Pdf.generatePdf();
    },

    async refresh() {
      this.loading = true;
      let { start, end } = this.dateRange;
      if (!start) {
        start = "";
      }
      if (!end) {
        end = moment().format("YYYY-MM-DD");
      }
      await this.invoiceGetStatementAll({
        clientId: this.clientId,
        dateEnd: end,
        dateStart: start,
      });
      await this.invoiceGetStatementSummary({
        clientId: this.clientId,
        dateEnd: end,
        dateStart: start,
      });
      this.loading = false;
    },


  },

  async created() {
    await this.refresh();
  },
};
</script>
